<template>
    <button title="Sign out of current login" class="signOut" v-on:click='signOut()'>
        <strong>{{fullName}} <br></strong>
        <small>{{username}} <br>
            Sign Out</small>
    </button>
</template>

<script>
    import {loadModules} from 'esri-loader';

    export default {
        name: 'auth',
        data: function(){
            return {
                username: '',
                fullName: '',
            }
        },
        methods: {
            signOut: function () {
                this.esriId.destroyCredentials();
                window.location.reload();
            }
        },
        mounted() {
            // lazy load the required ArcGIS API for JavaScript modules and CSS
            let vue_this = this;
            loadModules(["esri/portal/Portal",
                "esri/identity/OAuthInfo",
                "esri/identity/IdentityManager"], {css: true})
                .then(([Portal, OAuthInfo, esriId]) => {
                    var info = new OAuthInfo({
                        appId: "ra1Mtw6DUquoU7ud",
                        authNamespace: "portal_oauth_inline",
                        popup: false
                    });

                    this.esriId = esriId;

                    this.esriId.registerOAuthInfos([info]);

                    this.esriId
                        .checkSignInStatus(info.portalUrl + "/sharing")
                        .then(function () {
                            // displayItems();
                            console.log('signed in')
                        })
                        .catch(/*give user an option to sign in*/);

                    this.esriId.getCredential(info.portalUrl + "/sharing");

                    var portal = new Portal();
                    // Setting authMode to immediate signs the user in once loaded
                    portal.authMode = "immediate";
                    portal.load().then(function () {
                            vue_this.username = portal.user.username
                            vue_this.fullName = portal.user.fullName
                        }
                    );
                });
        },
    };

</script>

<style scoped>
    .signOut {
        max-width: fit-content;
        background: white;
        padding: 3px 10px;
        border-width: 1px;
        border-style: solid;
        border-color: #d2cece;
    }
</style>